import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { TheftReport } from '../../../../types';

type CellParams = ICellRendererParams<TheftReport>;

@Component({
  selector: 'app-cell-theft-report-datagrid-instance',
  imports: [UiModule, FormsModule, MatTooltipModule, MatIconModule],
  templateUrl: './cell-theft-report-datagrid-instance.component.html',
  styleUrl: './cell-theft-report-datagrid-instance.component.scss',
})
export class CellTheftReportDatagridInstanceComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
